import styled from 'styled-components'
import { parseRem } from 'styles'

interface TitleSectionProps {
  bg?: string
}

export const Wrapper = styled.header<TitleSectionProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
`

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${parseRem(8)};
`
